/**
 * Returns the number of remaining urgency days for a job based on its featuredConsumptions.
 * Returns null if the job is not featured, has no featuredConsumptions, or the urgency period has expired.
 */
export function getActiveUrgencyDays(job: any): number | null {
  if (!job?.isFeatured || !job?.featuredConsumptions?.length) return null;
  const lastConsumption = job.featuredConsumptions[job.featuredConsumptions.length - 1];
  const fromDate = new Date(lastConsumption.fromDate);
  const dayCount = lastConsumption.dayCount ?? 1;
  const urgencyEndDate = new Date(fromDate.getTime() + (dayCount * 24 * 60 * 60 * 1000));
  const days = Math.ceil((urgencyEndDate.getTime() - Date.now()) / (1000 * 60 * 60 * 24));
  return days > 0 ? days : null;
}
